<template>
<div class="app">
    <div class="header has-header">
        <div class="icons-submenu">
            <div class="defaultheader icon-submenu" v-bind:class="{active: viewMode == 1}" @click="viewMode = 1">
                <div class="label">Stammdaten</div>
            </div>
            <div class="defaultheader icon-submenu last" v-bind:class="{active: viewMode == 2}" @click="viewMode = 2">
                <div class="label">Übersicht</div>
            </div>
            
            
        </div>
        
        <div class="icons-submenu" style="margin-left:30px;">
            <div class="defaultheader icon-submenu " v-bind:class="{active: viewMode == 3}" @click="viewMode = 3">
                <div class="label">Monatsabschlüsse</div>
            </div>
            <div class="defaultheader icon-submenu " v-bind:class="{active: viewMode == 4}" @click="viewMode = 4">
                <div class="label">Plan Typen</div>
            </div>
            <div class="defaultheader icon-submenu last" v-bind:class="{active: viewMode == 5}" @click="viewMode = 5">
                <div class="label">Freizeit Optionen</div>
            </div>
        </div>
    </div>
    <b-container fluid class="scrollbar-container has-header-important">
        
        <b-row v-if="viewMode == 1">
            <b-col>
                <employeedata></employeedata>
            </b-col>
        </b-row>
        <b-row v-if="viewMode == 2">
            <b-col>
                <employeeoverview></employeeoverview>
            </b-col>
        </b-row>
         <b-row v-if="viewMode == 3">
            <b-col>
                <employeeworkbalanceoverview></employeeworkbalanceoverview>
            </b-col>
        </b-row>
        <b-row v-if="viewMode == 4">
            <b-col>
                <employeetypeoverview></employeetypeoverview>
            </b-col>
        </b-row>
        <b-row v-if="viewMode == 5">
            <b-col>
                <employeerulesoverview></employeerulesoverview>
            </b-col>
        </b-row>
        <br>
    </b-container>
</div>
</template>

<script>
import employeedata from './EmployeeData.vue'
import employeeoverview from './EmployeeOverview'

import employeeworkbalanceoverview from './EmployeeWorkBalanceOverview.vue'
import employeetypeoverview from '../plancontext/EmployeeTypeOverview.vue'
import employeerulesoverview from '../plancontext/EmployeeRulesOverview.vue'

export default {
    components: {
        employeetypeoverview,
        employeerulesoverview,
        employeeworkbalanceoverview,
        employeedata,
        employeeoverview
    },
    name: 'EmployeeSettings',
    data() {
        return {
            viewMode: 1, 
            loading: true,
        }
    },
    watch: {},
    props: {},
    created() {
        window.employeesettings = this;
        var settings = this;
    },
    mounted(){
       
        
    },
    updated() {},
    destroyed() {},
    methods: {
        
    }
}
</script>